<template>
  <main>
    <div class="flex justify-center">
      <Message severity="error" class="text-4xl font-bold px-16">
        Vous n'avez pas accès à la page que vous avez demandé
      </Message>
    </div>
    <div class="flex justify-center mt-8">
      <RouterLink to="/">
        <Button severity="info" class="font-bold px-8"> Retour à l'accueil </Button>
      </RouterLink>
    </div>
  </main>
</template>

<script setup></script>
